import { useQuery } from '@tanstack/react-query';
import { getRouteWareclouds } from '../../../services';

export default function useGetRouteWareclouds() {
  return useQuery({
    queryKey: ['get-route-wareclouds'],
    queryFn: () => getRouteWareclouds(),
    select: (data) => {
      return data.data.map(({ id_warecloud, first_name, last_name }) => ({
        label: `${first_name} ${last_name}`,
        value: id_warecloud,
      }));
    },
    staleTime: 1000 * 60 * 60 * 24,
  });
}
